import React from 'react';
import { Chip, Tooltip } from '@material-ui/core';

const KEYWORD_CONFIG = {
  PEP: { label: 'Political Exposed Person', color: '#1976d2' },
  SAN: { label: 'Sanction', color: '#d32f2f' },
  SI: { label: 'Special Interest', color: '#7b1fa2' },
  AM: { label: 'Adverse Media', color: '#ed6c02' },
  FR: { label: 'Financial Regulator', color: '#2e7d32' },
  LF: { label: 'Law Enforcement', color: '#d32f2f' },
  POI: { label: 'Profile of Interest', color: '#607d8b' },
  OOL: { label: 'Other Official Lists', color: '#00acc1' },
};

const KeywordChip = ({ code, classes }) => {
  const config = KEYWORD_CONFIG[code] || {};

  return (
    <Tooltip title={config.label || code}>
      <Chip
        label={code}
        size="small"
        className={classes?.tag}
        style={{
          backgroundColor: config.color || '#9e9e9e',
          color: 'white'
        }}
      />
    </Tooltip>
  );
};

export default KeywordChip;